import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { MdDelete } from "react-icons/md";
import "./Enquiry.css";
import axios from "axios";
import Swal from "sweetalert2";
import Topbar from "../Topbar/Topbar";
import AddEnquiry from "./AddEnquiry";
import dayjs from 'dayjs';
import { useSelector } from "react-redux";
import Map from '../images/mapicon.svg'



export default function Enquiry({ leadId, onDeleteSuccess }) {
  const apiUrl = process.env.REACT_APP_API_BASE_URL;
  const navigate=useNavigate()
    const permissions = useSelector((state) => state.permissions); // Adjust based on your reducer path
  

  let [data, setData] = useState([]);
  const [customerdelete, setcustomerdelete] = useState(false);
  const [filters, setFilters] = useState({
    leadId: "",
    leadStartedDate: "",
    accountManager: "",
    leadStatus: "",
    customerName: "",
    emailId: "",
    contactNum: "",
    alternateNum: "",
    address: "",
    Location: "",
    leadSource: "",
    createdby: "",
    updatedBy: "",
    updatedAt: "",
    notes: "",
    followUpDate: "",
  });


  const [columnVisibility, setColumnVisibility] = useState({
      // selectAll: true,
      leadId: true,
      createdDate: true,
      accountManager: true,
      leadStatus: true,
      customerName: true,
      emailId: true,

      contactnum: true,
      alternatenum: true,
      address: true,
      location: true,
      leadSource: true,
     
createdBy:true,
updatedBy:true,
updatedAt:true,

      notes: true,
      followUpDate:true,
     
    });


    const handleColumnVisibilityChange = (e) => {
      const { name, checked } = e.target;
      setColumnVisibility((prev) => ({
        ...prev,
        [name]: checked,
      }));
    };
  const [setting, setSetting] = useState(false);

    const settingPopup = (e) => {
      e.preventDefault();
      setSetting(!setting);
    };

  const handleDelete = async (leadId) => {
    // Show confirmation popup
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "you want to delete this data!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!",
    });

    if (result.isConfirmed) {
      try {
        // API Call to delete user
        await axios.post(apiUrl+"deleteenquiry", {
          leadId: leadId

        });

        // Success message
        Swal.fire("Deleted!", "Your data has been deleted.", "success");
        setcustomerdelete(true);

        // if (onDeleteSuccess) {
        //   onDeleteSuccess();
        // }
      } catch (error) {
        // Error handling
        Swal.fire("Error!", "Something went wrong while deleting.", "error");
        console.error("Delete Error:", error);
      }
    }
  };

    const formatDate = (date) => {
      return dayjs(date).format('DD-MM-YYYY');
    };

  const navi = useNavigate();

  const add = () => {
    navi("/addenquiry");
  };

  const [phoneNumber1, setPhoneNumber1] = useState("");
  const [phoneNumber2, setPhoneNumber2] = useState("");
  const [email, setEmail] = useState("");
  //   const [errors, setErrors] = useState({});

  // const phoneRegex = /^[7-9]{1}[0-9]{9}$/;

  // // Regex for validating email
  // const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;

  // const handleChange = (e) => {
  //   const { name, value } = e.target;
  //   if (name === "phoneNumber1") {
  //     setPhoneNumber1(value);
  //   } else if (name === "phoneNumber2") {
  //     setPhoneNumber2(value);
  //   } else if (name === "email") {
  //     setEmail(value);
  //   }
  // };

  // const validateForm = () => {
  //   const newErrors = {};

  //   // Validate Phone Number 1
  //   if (!phoneRegex.test(phoneNumber1)) {
  //     newErrors.phoneNumber1 =
  //       "Please enter a valid 10-digit phone number (starting with 7-9)";
  //   }

  //   // Validate Phone Number 2 (Optional)
  //   if (phoneNumber2 && !phoneRegex.test(phoneNumber2)) {
  //     newErrors.phoneNumber2 =
  //       "Please enter a valid 10-digit phone number (starting with 7-9)";
  //   }

  //   // Validate Email
  //   if (!emailRegex.test(email)) {
  //     newErrors.email = "Please enter a valid email address";
  //   }

  //   return newErrors;
  // };

  // const [setting, setSetting] = useState(false);
  // const settingPopup = (e) => {
  //   e.preventDefault();
  //   setSetting(!setting);
  // };


  const getLeadStatusColor = (status) => {
    if (!status) return "";
    switch (status.toLowerCase().trim()) {
      case "hold":
        return "status-hold";
      case "no response":
        return "status-noresponse";
      case "converted":
        return "status-converted";
      case "not feasible":
        return "status-notfeasible";
        case "cancelled":
          return "status-cancelled";
          case "open":
            return "status-open";
      default:
        return "";
    }
  };

 const gotoviewenquiry = (id) => {
  navi("/view_enquiry", {
    state: { id: id },
  });
};

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters((prevFilters) => ({
      ...prevFilters,
      [name]: value.toLowerCase(), // Normalize input for case-insensitive search
    }));
  };

  const filteredData = data?.filter((customer) => {
    return Object.keys(filters).every((key) => {
      if (!filters[key]) return true; // Skip empty filters
      return String(customer[key]).toLowerCase().includes(filters[key]);
    });
  });

console.log(data)
  
const [leadCounts, setLeadCounts] = useState({});

  // useEffect(() => {
  //   axios.post( apiUrl +"view-enquiry", {}).then((res) => {
  //     const add_installation = res.data.message || [];
  //     console.log("Fetched data:", add_installation); // ✅ Check this output
  
  //     setData(add_installation);

  //     const holdCount = add_installation.filter(
  //       (c) => c.leadStatus?.toLowerCase() === "hold"
  //     ).length;
      
  //     const noResponseCount = add_installation.filter(
  //       (c) => c.leadStatus?.toLowerCase() === "no response"
  //     ).length;
  
  //     const counts = {
  //       open: add_installation.filter((c) => c.leadStatus === "open").length,
  //       hold: holdCount,
  //       noResponse: noResponseCount,
  //       progress: holdCount + noResponseCount,
  //       notFeasible: add_installation.filter((c) => c.leadStatus === "Not Feasible").length,
  //       cancelled: add_installation.filter((c) => c.leadStatus === "Cancelled").length,
  //       converted: add_installation.filter((c) => c.leadStatus === "Converted").length,
  //     };
  
  //     console.log("Status Counts:", counts); // ✅ Check if counts are calculated correctly
  
  //     setStatusCounts(counts);
  //   });
  // }, [customerdelete]);
  
   const handleMapClick = () => {
    navigate("/taskmapview?page=enquiry");
  };
useEffect(() => {
  axios.post(apiUrl + "view-enquiry", {}).then((res) => {
    console.log("Raw API response:", res.data);

    const add_installation = Array.isArray(res.data.message) ? res.data.message : [];

    // Reverse array so last item comes first
    const sortedData = [...add_installation].reverse();

    console.log("Sorted data:", sortedData);

    setData(sortedData);
  });
}, [customerdelete, apiUrl]);




  let changedata = (data) =>
    {
      if(data == "leadId")
      {
        return "  Lead Id"
      }
      if(data == "createdDate")
        {
          return " Created Date"
        }
        if(data == "accountManager")
          {
            return " Account Manager"
          }
          if(data == "leadStatus")
            {
              return " Lead Status"
            }
        if(data == "customerName")
          {
            return " Customer Name"
          }
      if(data == "emailid")
         {
              return " Email ID"
        }   
         
  
          if(data == "contactnum")
            {
              return " Contact Number"
            }
            if(data == "alternatenum")
              {
                return " Alternate Number"
              }     
    if(data == "address")
          {
                  return " Address "
      }
      if(data == "location")
        {
          return " Location"
        }
        if(data == "leadSource")
          {
            return " Lead Source"
          } 
          
          if(data == "createdBy")
            {
              return " Created By"
            }
   if(data == "updatedBy")
  {
      return " Updated By"
  } 

  if(data == "updatedAt")
    {
        return " Updated At"
    } 
  
    if(data == "notes")
      {
          return " Notes"
      }
      
      if(data == "followUpDate")
        {
            return " Follow Up Date"
        }
        
       
      else
      {
        return data;
      }
  
     
        
    }

  
  

  useEffect(() => {
    axios
      .get(apiUrl+"enquiry-status")
      .then((res) => setLeadCounts(res.data))
      .catch((err) => console.error("Enquiry status error:", err));
  }, [apiUrl]);

  
  return (
    <div className="customer-scroll-stop">
      <Topbar />
      <Container fluid className=" pt-1 customer-row ">
        <h3 className=" px-2  ">
           Enquiry 
        </h3>

{permissions?.Enquiry?.["Enquiry Statistics"]?.Read && (
        <Row className=" row-width">
          <Col className="dashborder mt-4   mb-5 mx-2 ">
            <Row className="yellow-card">
              <p className="text-center box-txt " style={{ marginTop: "6px" }}>
                Open
              </p>
            </Row>
            <Row className="number">
              <h5 className="text-center pt-1">{leadCounts["Open"] ?? 0}</h5>
            </Row>
          </Col>
          {/* <Col className="dashborder mt-4 mb-5 mx-1  ">
            <Row className="grey-card">
              <p className="text-center pt-1 box-txt">Progress</p>
            </Row>
            <Row className="number">
              <h5 className="text-center">{statusCounts.progress}</h5>
            </Row>
          </Col> */}
          <Col className="dashborder mt-4 mb-5  mx-1">
            <Row className="orange-card ">
              <p className="text-center pt-1 box-txt">Hold</p>
            </Row>
            <Row className="number">
              <h5 className="text-center pt-1">{leadCounts["Hold"] ?? 0}</h5>
            </Row>
          </Col>
          <Col className="dashborder mt-4 mb-5 mx-1">
            <Row className="pink-card row-margin">
              <p className="text-center pt-1 box-txt">No Response</p>
            </Row>
            <Row className="number">
              <h5 className="text-center pt-1">{leadCounts["No Response"] ?? 0}</h5>
            </Row>
          </Col>
          {/* <Col className="dashborder mt-4 mb-5 mx-1">
            <Row className="purple-card">
              <p className="text-center pt-1 box-txt " style={{ marginTop: "8px" }}>Not Interested</p>
            </Row>
            <Row className="number">
              <h5 className="text-center pt-1">{statusCounts.notInterested}</h5>
            </Row>
          </Col> */}
          <Col className="dashborder mt-4 mb-5 mx-1">
            <Row className="blue-card">
              <p className="text-center pt-1 px-1 box-txt">Not Feasible</p>
            </Row>
            <Row className="number">
              <h5 className="text-center pt-1">{leadCounts["Not Feasible"] ?? 0}</h5>
            </Row>{" "}
          </Col>
          <Col className="dashborder mx-1  mt-4 mb-5">
            <Row className="green-card">
              <p className="text-center pt-1 box-txt">Converted</p>
            </Row>
            <Row className="number">
              <h5 className="text-center pt-1">{leadCounts["Converted"] ?? 0}</h5>
            </Row>
          </Col>
          <Col className="dashborder mx-1  mt-4 mb-5">
            <Row className="red-card">
              <p className="text-center pt-1 box-txt">Cancelled</p>
            </Row>
            <Row className="number">
              <h5 className="text-center pt-1">{leadCounts["Cancelled"] ?? 0}</h5>
            </Row>
          </Col>
        </Row>
)}


        <Row className=" button-bottom-custmer" xs={1} sm={2}>
          <Col className="mt-2 mb-2" md={5}>


          {permissions?.Enquiry?.["Add Enquiry"]?.Write && (
           <button
  onClick={ ()=>
  {
add()
  }
   
      // Call your function here, e.g., add();
      
    
  }

  className="black-btn btnadd black-btn1"
>
              Add
            </button>
          )}
          {" "}
            &emsp;&emsp;
            <button
              onClick={() => window.location.reload()}
              className="black-btn black-btn1"
            >
              Refresh
            </button>
          </Col>

          <Col className="btn-Ccolumn2 mt-2" md={6} >
            {/* <button
              className="black-btn black-btn1 btnadd"
            >
              Export
            </button> */}
            &emsp;&emsp;
            <button
              onClick={settingPopup}
              className="black-btn black-btn1 ">
              Settings
            </button>
            {setting && (
              
              <div className="setting-popup-overlay">
                <div className="setting-popup-container">
                  <button className="setting-close-btn" onClick={settingPopup}>
                    &times;
                  </button>
                  <div className="setting-popup-content">
                  <div className="setting-checkbox-row">
  <label>
    <input
      className="checkbox-customer"
      type="checkbox"
      checked={Object.values(columnVisibility).every((v) => v)}
      onChange={(e) => {
        const isChecked = e.target.checked;
        setColumnVisibility(
          Object.keys(columnVisibility).reduce((acc, key) => {
            acc[key] = isChecked;
            return acc;
          }, {})
        );
      }}
    />
    <span className="checkbox-down ms-1" style={{ fontSize: "17px" }}>
      {Object.values(columnVisibility).every((v) => v) ? "Unselect All" : "Select All"}
    </span>
  </label>
</div>

                    <div className="setting-checkbox-grid">
                      {Object.keys(columnVisibility).map((key) => (
                        <label key={key} className="label-setting-popup">
                          <input
                            type="checkbox"
                            name={key}
                            checked={columnVisibility[key]}
                            onChange={handleColumnVisibilityChange}
                            className="checbox-popup"
                          />
                          <span className="checkbox-down1">
                            {changedata(key)}
                          </span>
                        </label>
                      ))}
                    </div>
 
                    <button
                      className="setting-submit-btn"
                      onClick={settingPopup}
                    >
                      Submit
                    </button>
 
                  </div>
                </div>
              </div>
            )}
          </Col>
           <Col md={1}>
                      <img src={Map} alt="map"  style={{width:"30px",height:"30px"}}
            className="map-icon text-end"
                      onClick={handleMapClick}/>
                    </Col>
        </Row>

        <br />


        
{permissions?.Enquiry?.["Enquiry Module"]?.Read && (

        <div className="table-responsive">
          <table className="table table-bordered table-sm">
            <thead className="table-th text-center">
              <tr>
              {columnVisibility.leadId && (
                <th className="table-th-content">Lead ID</th>
              )}
                  {columnVisibility.leadStartedDate && (
                <th className="table-th-content">Lead Started Date</th>
                  )}
                      {columnVisibility.accountManager && (
                <th className="table-th-content">Account Manager</th>
                      )}
               {columnVisibility.leadStatus && (
                <th className="table-th-content">Lead Status</th>
               )}
                   {columnVisibility.customerName && (
                <th className="table-th-content">Customer Name</th>
                   )}
                {columnVisibility.emailId && (
                <th className="table-th-content">Mail ID</th>
                )}
                    {columnVisibility.contactnum && (
                <th className="table-th-content">Contact Number</th>
                    )}
                 {columnVisibility.alternatenum && (
                <th className="table-th-content">Alternate Number</th>
                 )}
                     {columnVisibility.address && (
                <th className="table-th-content">Address</th>
                     )}
                  {columnVisibility.location && (
                <th className="table-th-content">Location</th>
                  )}
                      {columnVisibility.leadSource && (
                <th className="table-th-content">Lead Source</th>
                      )}
                          {columnVisibility.createdBy && (
                <th className="table-th-content">Created BY</th>
                          )}
                    {columnVisibility.updatedBy && (
                <th className="table-th-content">Updated By</th>
                    )}
                        {columnVisibility.updatedAt && (
                <th className="table-th-content">Updated At</th>
                        )}
                            {columnVisibility.notes && (
                <th className="table-th-content">Notes</th>
                            )}
                                {columnVisibility.followUpDate && (
                <th className="table-th-content">Follow Up Date</th>
                                )}


                                
{permissions?.Enquiry?.["Enquiry Statistics"]?.Delete && (
                <th className="table-th-content">Delete</th>

)}
              </tr>
            </thead>

            <tbody>
              <tr>
              {columnVisibility.leadId && (
                <td>
                  <input
                    type="text"
                    className="table-search background-change"
                    name="leadId"
                    onChange={handleFilterChange}
                    placeholder="Search.."
                  />
                </td>
              )}
                  {columnVisibility.leadStartedDate && (
                <td>
                  <input
                    className="table-search background-change"
                    type="date"
                    name="createdDate"
                    onChange={handleFilterChange}
                  />
                </td>
                  )}
                      {columnVisibility.accountManager &&  (
                <td>
                  <input
                    className="table-search background-change"
                    type="text"
                    style={{ textTransform: "capitalize" }}
                    name="enquiryaccountManager"
                    onChange={handleFilterChange}
                    placeholder="Search "
                  />
                </td>
                      )}
                  {columnVisibility.leadStatus && (
                <td>
                  <select
                    className="table-search background-change"
                    name="enquiryleadStatus"
                    onChange={handleFilterChange}
                  >
                    <option>Select</option>
                    <option value="Open">Open</option>
                    <option value="Hold">Hold</option>
                    <option value="No Response">No Response</option>
                    <option value="Converted">Converted</option>
                    <option value="Not Feasible">Not Feasible</option>
                    <option value="Cancelled">Cancelled</option>


                  </select>
                </td>
                  )}
                  {columnVisibility.customerName && (

                <td>
                  <input
                    className="table-search background-change"
                    type="text"
                    style={{ textTransform: "capitalize" }}
                    name="enquirycustomerName"
                    onChange={handleFilterChange}
                    placeholder="Search "
                  />
                </td>
                  )}
                {columnVisibility.emailId && (


                <td>
                  <input
                    type="email"
                    className="table-search background-change"
                    name="enquiryemailId"
                    onChange={handleFilterChange}
                    placeholder="Search "
                  />
                </td>
                )}
                {columnVisibility.contactnum && (
                <td>
                  <input
                    type="tel"
                    className="table-search background-change"
                    name="enquirycontactNum"
                    onChange={handleFilterChange}
                    placeholder="Search "
                    onKeyDown={(e) => {
                      if (
                        ["e", "E", "+", "-"].includes(e.key) ||
                        (!/[0-9]/.test(e.key) &&
                          e.key !== "Backspace" &&
                          e.key !== "ArrowLeft" &&
                          e.key !== "ArrowRight")
                      ) {
                        e.preventDefault();
                      }
                    }}
                  />
                </td>
                )}
                {columnVisibility.alternatenum && (
                <td>
                  <input
                    type="tel"
                    className="table-search background-change"
                    name="enquiryalternateNum"
                    onChange={handleFilterChange}
                    placeholder="Search "
                    onKeyDown={(e) => {
                      if (
                        ["e", "E", "+", "-"].includes(e.key) ||
                        (!/[0-9]/.test(e.key) &&
                          e.key !== "Backspace" &&
                          e.key !== "ArrowLeft" &&
                          e.key !== "ArrowRight")
                      ) {
                        e.preventDefault();
                      }
                    }}
                  />
                </td>
                )}
                {columnVisibility.address && (
                <td>
                  <input
                    type="text"
                    className="table-search background-change"
                    style={{ textTransform: "capitalize" }}
                    name="enquiryaddress"
                    onChange={handleFilterChange}
                    placeholder="Search "
                  />
                </td>
                )}
                {columnVisibility.location && (

                <td>
                  <input
                    type="text"
                    className="table-search background-change"
                    style={{ textTransform: "capitalize" }}
                    name="enquirylocation"
                    onChange={handleFilterChange}
                    placeholder="Search "
                  />
                </td>
                )}
{columnVisibility.leadSource && (
                <td>
                  <select
                    className="table-search background-change"
                    name="enquiryleadSource"
                    onChange={handleFilterChange}
                  >
                    <option>Select</option>
                    <option value="Facebook">Facebook</option>
                    <option value="Insta">Insta</option>
                    <option value="Google Ads">Google Ads</option>
                  </select>
                </td>
)}
                {columnVisibility.createdBy && (

                <td>
                  <input
                    className="table-search background-change"
                    type="text"
                    name="enquirycreatedBy"
                    onChange={handleFilterChange}
                    placeholder="Search "
                  />
                </td>
                )}
                {columnVisibility.updatedBy && (

                <td>
                  <input
                    className="table-search background-change"
                    type="text"
                    name="enquiryupdatedBy"
                    onChange={handleFilterChange}
                    placeholder="Search "
                  />
                </td>
                )}
                {columnVisibility.updatedAt && (

                <td>
                  <input
                    type="date"
                    className="table-search background-change"
                    name="enquiryupdatedAt"
                    onChange={handleFilterChange}
                  />
                </td>
                )}
                {columnVisibility.notes && (

                <td>
                  <input
                    type="text"
                    className="table-search background-change"
                    style={{ textTransform: "capitalize" }}
                    name="enquirynotes"
                    onChange={handleFilterChange}
                    placeholder="Search "
                  />
                </td>
                )}
                {columnVisibility.followUpDate && (
                <td>
                  <input
                    type="date"
                    className="table-search background-change"
                    name="enquiryFollowUpDate"
                    onChange={handleFilterChange}
                  />
                </td>
                )}
              </tr>


              {/* {filteredData.map((d, i) => (
                <tr key={i}>
                  <td>{d.leadId}</td>
                  <td>{d.createdDate}</td>
                  <td>{d.enquiryaccountManager}</td>
                  <td>{d.enquiryleadStatus}</td>
                  <td>{d.enquirycustomerName}</td>
                  <td>{d.enquiryemailId}</td>
                  <td>{d.enquirycontactNum}</td>
                  <td>{d.enquiryalternateNum}</td>
                  <td>{d.enquiryaddress}</td>
                  <td>{d.enquirylocation}</td>
                  <td>{d.enquiryleadSource}</td>
                  <td>{d.enquirycreatedBy}</td>
                  <td>{d.enquiryupdatedBy}</td>
                  <td>{d.enquiryupdatedAt}</td>
                  <td>{d.enquirynotes}</td>
                  <td>{d.enquiryFollowUpDate}</td>

                  <td>
                    <button
                      className="deletebtn text-center"
                      onClick={() => handleDelete(d.leadId)}
                    >
                      <MdDelete size={20} />
                    </button>
                  </td>
                </tr>
              ))} */}

{Array.isArray(filteredData) && filteredData.length > 0 ? (
  filteredData.map((d, i) => (
    <tr key={i}>
      {columnVisibility.leadId && (
      <td  onClick={() => {
      if (permissions?.["Enquiry"]?.["Enquiry Module"]?.Write)
         {
        gotoviewenquiry(d._id);
      } 
    }}
     style={{
      cursor: permissions?.["Enquiry"]?.["Enquiry Module"]?.Write
        ? "pointer"
        : "not-allowed",
     
    }}>{d.leadId }</td>
      )}
      {columnVisibility.leadStartedDate && (
      <td>{formatDate(d.createdDate)}</td>
      )}
      {columnVisibility.accountManager && (
      <td>{d.enquiryaccountManager?.staffName }</td>
      )}
      {columnVisibility.leadStatus && (
      <td>
      <span className={getLeadStatusColor(d.leadStatus)}>
            <span style={{textTransform:"capitalize"}}>{d.leadStatus}</span>
          </span>
          </td>
      )}
      {/* <td>{d.enquiryleadStatus || "N/A"}</td> */}
      {columnVisibility.customerName && (
                  <td>{d.enquirycustomerName }</td>
      )}
      {columnVisibility.emailId && (
                  <td>{d.enquiryemailId }</td>
      )}
      {columnVisibility.contactnum && (
                  <td>{d.enquirycontactNum}</td>
      )}
      {columnVisibility.alternatenum && (
                  <td>{d.enquiryalternateNum }</td>
      )}
      {columnVisibility.address && (
                  <td>{d.enquiryaddress }</td>
      )}
      {columnVisibility.location && (
                   <td>
                        {d.location?.latitude 
                          ? `${d.location.latitude}, ${d.location.longitude}`
                          : "N/A"}
                 </td>
      )}
      {columnVisibility.leadSource && (
                  <td>{d.enquiryleadSource }</td>
      )}
      {columnVisibility.createdBy && (
                  <td>{d.createdBy?.staffName }</td>
      )}
                  {columnVisibility.updatedBy && (
                  <td>{d.updatedBy?.staffname }</td>
                  )}
                  {columnVisibility.updatedAt && (
                  <td>{d.updatedBy?.date } {d.updatedBy?.time}</td>
                  )}
                  {columnVisibility.notes && (
                  <td>{d.enquiryleadStatus?.enquirynotes
 }</td>
                  )}
                  {columnVisibility.followUpDate && (
                  <td>{d.enquiryleadStatus?.enquiryLeadStatusnextFollowUpDate }</td>
                  )}

{permissions?.Enquiry?.["Enquiry Statistics"]?.Delete && (
                  <td>
                    <button
                      className="deletebtn text-center"
                      onClick={() => handleDelete(d._id)}
                    >
                      <MdDelete size={20} />
                    </button>
                  </td>
)}
      
    </tr>
  ))
) : (
  <tr>
    <td colSpan="16" className="text-center">No data available</td>
  </tr>
)}

            </tbody>
          </table>

        </div>
)}
      </Container>
    </div>
  );
}